<template>
    <div class="row">
        <div class="col-md-12">
            <label class="font-weight-bold">{{ __('general.brand') }}</label>
            <h2>{{ brand.name }}</h2>
        </div>
    </div>
</template>

<script>
import UserRequestLayout from '@layouts/UserRequestLayout.vue'

export default {
    layout: UserRequestLayout,

    props: {
        userRequest: Object,
        brand: Object,
    },
}
</script>
